import { homeRoute, profileRoute } from "./routes";

import { CampaignIndexRouter } from "./pages/campaign/index-router";
import {
  CampaignWrapper,
  InGameCampaignWrapper,
} from "./components/campaign-wrapper";
import { Home } from "./pages/home";
import { Layout } from "./components/layout";
import { Profile } from "./pages/profile";
import { createMemoryRouter } from "react-router-dom";

export const routerOnSite = createMemoryRouter(
  [
    {
      element: <Layout />,
      children: [
        {
          path: homeRoute,
          element: <Home />,
        },
        {
          path: profileRoute,
          element: <Profile />,
        },
        {
          path: "campaign",
          element: <CampaignWrapper />,
          children: [
            {
              index: true,
              element: <CampaignIndexRouter />,
            },
            {
              path: "overview",
              element: <CampaignIndexRouter />,
            },
          ],
        },
      ],
    },
  ],
  {
    initialEntries: [homeRoute],
  }
);

export const routerInGame = createMemoryRouter(
  [
    {
      element: <Layout />,
      children: [
        {
          path: "campaign",
          element: <InGameCampaignWrapper />,
          children: [
            {
              index: true,
              element: <CampaignIndexRouter />,
            },
            {
              path: "overview",
              element: <CampaignIndexRouter />,
            },
          ],
        },
      ],
    },
  ],
  {
    initialEntries: ["/campaign"],
  }
);
